import type {
  LayerRegistryEntry,
  StrategyCategory,
  StrategyLayerKind,
} from "@/types/strategy";

/**
 * Factory helper to define a strategy with less boilerplate.
 *
 * Layer params hold only relative geometry (pivot, d_leg_N, structural
 * knobs). The strike anchor lives in `simulatorStore.entrySpot` and is
 * threaded into `effectiveSpot(entrySpot, params)` at compute time —
 * never materialized into JSONB.
 */
export function defineStrategy(
  kind: StrategyLayerKind,
  label: string,
  category: StrategyCategory,
  config: Omit<LayerRegistryEntry, "kind" | "label" | "category">,
): LayerRegistryEntry {
  return { kind, label, category, ...config };
}
